import { FC } from 'react';

import { Button } from '@hh.ru/magritte-ui';
import { BarsOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

interface HeaderMenuIconProps {
    onClick?: () => void;
}

const HeaderMenuIcon: FC<HeaderMenuIconProps> = ({ onClick }) => (
    <Button
        style="neutral"
        mode="tertiary"
        size="medium"
        icon={<BarsOutlinedSize24 />}
        aria-label="menu burger button"
        hideLabel
        onClick={onClick}
    />
);

export default HeaderMenuIcon;
